<template>
  <div class="tree-menu leaf">
    <div class="label-wrapper">
      <div :style="indent" :class="labelClasses" class="p-1 d-flex flex-row">
   <!-- <i v-if="nodes" class="fa" :class="iconClasses"></i>   -->
        <div @click="toggleChildren" class="flex-grow-1">
          <i v-if="childs"></i>
          {{ node.title }} <span v-if="childs && childs.length > 0">({{ childs.length }})</span>
        </div>
        <b-button variant="link" size="sm" borderless @click="showMenu" v-b-tooltip.hover title="Show Menu">
            <b-icon icon="three-dots" variant="dark"></b-icon>
        </b-button>
        
        <b-alert
            v-model="isMenuShow"
            class="myAlert position-fixed fixed-bottom m-0 p-0 rounded-0"
            style="z-index: 2000; height: 100%"
            variant="warning">
            
            <div class="d-flex flex-row-reverse" style="width:100%">
              <b-button variant="link" size="sm" borderless @click="hideMenu" v-b-tooltip.hover :title="'Close'">
                  <i class="fas fa-times-circle text-dark" aria-hidden="true"></i>
              </b-button> 
              <b-button variant="link" size="sm" borderless @click="onPaste()" v-if="hasPaste" v-b-tooltip.hover :title="'Paste ' + getNodeType">
                  <i class="fas fa-paste text-warning" aria-hidden="true"></i>
              </b-button>
              <b-button variant="link" size="sm" borderless @click="onCut()" v-if="hasCut" v-b-tooltip.hover :title="'Cut ' + getNodeType">
                  <i class="fa fa-cut text-dark" aria-hidden="true"></i>
              </b-button>
              <b-button variant="link" size="sm" borderless @click="onCopy()" v-if="hasCopy" v-b-tooltip.hover :title="'Duplicate ' + getNodeType">
                  <i class="fas fa-copy text-info" aria-hidden="true" ></i>
              </b-button>   
              <b-button variant="link" size="sm" borderless @click="onDelete()" v-if="hasDelete" v-b-tooltip.hover :title="'Delete ' + getNodeType">
                  <i class="fas fa-trash-alt text-danger" aria-hidden="true" ></i>
              </b-button>
              <b-button variant="link" size="sm" borderless @click="onEdit()" v-if="hasEdit" v-b-tooltip.hover :title="'Edit ' + getNodeType">
                  <i class="fas fa-edit text-primary" aria-hidden="true" ></i>
              </b-button>
              <b-button variant="link" size="sm" borderless @click="onAddChild()" v-if="hasAddChild" v-b-tooltip.hover :title="'New Child'">
                  <i class="fa fa-plus-square text-success" aria-hidden="true"></i>
              </b-button>                           
            </div>

        </b-alert>
      </div>
    </div>
    <div v-if="showChildren" class="branch">
      <draggable v-model="childs" @end="onEndDraggable">
          <tree-menu 
              v-for="(_node) in childs" 
              :node="_node"
              :parentNode="childs"
              :depth="depth + 1" 
              :bus="bus"
              :key="_node.uuid" >
          </tree-menu>
        </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
 components : { draggable },
 name: 'TreeMenu',
 props: [ 'node', 'parentNode', 'depth', 'bus'],
 data() {
     return {
       selectedNode : null,
       isMenuShow : false,
       showChildren : false,       
     }
  },
  computed: {
    hasEdit() { return true; }, //Section, Item, OptionGroup, Option
    hasDelete() { return true; },//Section, Item, OptionGroup, Option
    hasCopy() { return (this.depth === 1) || (this.depth === 2) || (this.depth === 3); },//Item, OptionGroup, Option
    hasCut() { return (this.depth === 1) || (this.depth === 2) || (this.depth === 3); },//Item, OptionGroup, Option
    hasPaste() { //Section, Item, OptionGroup
      return (this.selectedNode &&
              (this.selectedNode.method === "cut" || this.selectedNode.method === "copy") && this.selectedNode.depth - 1 === this.depth) && 
              (this.depth === 0 || this.depth === 1 || this.depth === 2);
    },
    hasAddChild() { return (this.depth === 0) || (this.depth === 1) || (this.depth === 2); },//Section, Item, OptionGroup

    iconClasses() {
      return {
        'fa-plus-square-o': !this.showChildren,
        'fa-minus-square-o': this.showChildren
      }
    },
    labelClasses() {
      return { 'has-children': this.childs }
    },
    indent() {
      const depth = 10;
      return { 
          width: `calc(100% - ${this.depth * depth}px)`,
          transform: `translate(${this.depth * depth}px)`,
          "background-color" : this.getBackgroundColor
      } 
    },
    getNodeType() {
      let type = "section"
      switch(this.depth){
        case 0 :
          type = "section"
          break;
        case 1 :
          type = "item"
          break;
        case 2 :
          type = "optiongroup"
          break;
        case 3 :
          type = "option"
          break;
      }
      return type;
    },
    getBackgroundColor() {
      let color = "#FFEBEE"
      switch(this.depth){
        case 0 :
          color = "#FFEBEE"
          break;
        case 1 :
          color = "#F3E5F5"
          break;
        case 2 :
          color = "#E3F2FD"
          break;
        case 3 :
          color = "#FFF3E0"
          break;
      }
      return color;
    },
    childs: {
       get() {
          switch(this.depth + 1) {
             case 0 : return this.node.sections;
             case 1 : return this.node.items;
             case 2 : return this.node.optionGroups;
             case 3 : return this.node.options;                                    
          }
          return [];
       },
       set(value) {
          switch(this.depth + 1) {
            case 0 :
              this.node.sections = value
              break;
            case 1 :
              this.node.items = value
              break;
            case 2 :
              this.node.optionGroups = value
              break;
            case 3 :
              this.node.options = value
              break;
          }
       } 
    }
  },
  created() {    
    this.selectedNode = this.bus.selectedNode; //Check for New Open (MenuSetup)
    this.bus.$on('selectedNode', (selectedNode) => {  //Check for Already Open (MenuSetup)
        this.selectedNode = selectedNode;
    });
  },
  destroyed() {
   // this.bus.$off('selectedNode');
  },
  methods: {
    toggleChildren() {
       this.showChildren = !this.showChildren;
    },
    showMenu() {
      this.isMenuShow = true;    
    },
    hideMenu(){
      this.isMenuShow = false;          
    },
    onEdit(event) {
      this.isMenuShow = false;
      this.bus.$emit('onSelectNode', { event : event, node : this.node, method : "edit", depth : this.depth});
    },
    onDelete(event) {
      this.isMenuShow = false;
      let index = this.parentNode.findIndex(({uuid}) => uuid === this.node.uuid);
      this.parentNode.splice(index, 1);
      this.bus.$emit('onSelectNode', { event : event, node : this.node, method : "delete", depth : this.depth});      
    },
    onCopy(event) {
      this.isMenuShow = false;
      this.bus.$emit('onSelectNode', { event : event, node : this.node, method : "copy", depth : this.depth});      
    },
    onCut(event) {
      this.isMenuShow = false;
      this.bus.$emit('onSelectNode', { event : event, node : this.node, parentNode : this.parentNode, method : "cut", depth : this.depth});
    },
    onPaste(event) {
      this.isMenuShow = false;

      let copyNode = this.$deepCopy(this.selectedNode);
      copyNode.node.uuid = this.$HashCode(copyNode.node.uuid + Date.now() + ""); //Assign New UUID

      if(this.selectedNode.method === "cut") {
        let index = this.selectedNode.parentNode.findIndex(({uuid}) => uuid === this.selectedNode.node.uuid);
        this.selectedNode.parentNode.splice(index, 1);
      }
      
      this.childs.push(copyNode.node);
      this.bus.$emit('onSelectNode', { event : event, node : this.node, method : "paste", depth : this.depth});      
    },
    onAddChild(event) {
      this.isMenuShow = false;
      this.bus.$emit('onSelectNode', { event : event, childs : this.childs, method : "addChild", depth : this.depth + 1}); 
    },
    onEndDraggable() {
      this.bus.$emit('onSelectNode', { method : "dragEnd" });
    }
  }
}
</script>

<style scoped lang="scss">
// .showModal >>> .modal {
//     width: unset;
// }
.tree-menu .label-wrapper {
    margin-top: 5px;
    margin-bottom: 5px;
    /* border-bottom: 1px solid #ccc; */
}

.tree-menu .label-wrapper .has-children {
    cursor: pointer;
}

.myAlert ::v-deep .close {
  padding : unset;
}
.myAlert {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>